// extracted by mini-css-extract-plugin
module.exports = {"noPadding":"renderasset_noPadding__eaKWI"};